// Store page <title> / <meta description> copy. The ONE owner.
//
// Why this file exists: `+title.ts`, `+description.ts` and `+Head.tsx` (twitter:* and the JSON-LD
// description) used to hold three hand-synced copies of the same formula (C4). They all call
// these helpers now, so they can never drift again.
//
// Why this copy: the 2026-10-05 Search Console review showed the old zero-review title
// «جديد على يتفرّج» wasting navigational impressions (/store/awad-serag: 1,574 impressions for
// 2 clicks in 28 days), while review-intent queries («عيوب…», «اراء الناس في…») convert at 20 to
// 50%. Reviewed stores therefore lead on «آراء وتجارب العملاء»; zero-review stores lead on the
// question the searcher is actually asking.
//
// D-09: never render a "0.0" rating. The reviewed variant requires BOTH a positive rating and a
// positive review count; anything else (including ratings-only stores at rating 0) falls to the
// zero-review variant.

export type StoreSeoInput = { name: string; rating: number; totalReviews: number };

const isReviewed = (store: StoreSeoInput): boolean =>
  store.totalReviews > 0 && store.rating > 0;

export const storeSeoTitle = (store: StoreSeoInput): string =>
  isReviewed(store)
    ? `${store.name}: آراء وتجارب العملاء، ${store.totalReviews} تقييم بمتوسط ${store.rating.toFixed(1)}/5 | يتفرج`
    : `${store.name}: هل هو موثوق؟ اعرف قبل ما تشتري | يتفرج`;

export const storeSeoDescription = (store: StoreSeoInput): string =>
  isReviewed(store)
    ? `آراء وتجارب العملاء مع ${store.name} على يتفرج: متوسط ${store.rating.toFixed(1)}/5 من ${store.totalReviews} تقييم. اقرأ التجارب الحقيقية قبل ما تشتري.`
    : `اعرف ${store.name} قبل ما تشتري: بيانات المتجر وطرق التواصل على يتفرج. لا توجد تقييمات بعد، كن أول من يشارك تجربته.`;
